import store from './store';

export default store;



// WEBPACK FOOTER //
// ./src/app/policies/index.js